import { render, staticRenderFns } from "./functionsDokPro.vue?vue&type=template&id=223d9f63&"
import script from "./functionsDokPro.vue?vue&type=script&lang=js&"
export * from "./functionsDokPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports